import React, { memo, Component } from 'react';
import { Phone, Printer, Share2 } from 'lucide-react';
export function VehicleInspectionAidPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5542">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-12" data-id="element-5543">
        <div className="container mx-auto px-4" data-id="element-5544">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center italic" data-id="element-5545">
            Vehicle Inspection Memory Aid
          </h1>
        </div>
      </div>

      {/* Print/Share Actions */}
      <div className="bg-white border-b-2 border-gray-200" data-id="element-5546">
        <div className="container mx-auto px-4 py-4" data-id="element-5547">
          <div className="max-w-6xl mx-auto flex justify-center gap-4" data-id="element-5548">
            <button onClick={() => window.print()} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors" data-id="element-5549">
              <Printer className="mr-2" size={18} data-id="element-5550" />
              Print this page
            </button>
            <button onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: 'Vehicle Inspection Memory Aid',
                text: 'Check out this vehicle inspection memory aid',
                url: window.location.href
              });
            }
          }} className="flex items-center bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors" data-id="element-5551">
              <Share2 className="mr-2" size={18} data-id="element-5552" />
              Send Page to Friend
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8" data-id="element-5553">
        <div className="max-w-6xl mx-auto" data-id="element-5554">
          {/* Top Row - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4" data-id="element-5555">
            {/* Engine Compartment */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5556">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5557">
                <h2 className="font-bold text-center text-sm" data-id="element-5558">
                  Engine Compartment
                </h2>
              </div>
              <div className="p-4" data-id="element-5559">
                <ul className="space-y-1 text-sm" data-id="element-5560">
                  <li data-id="element-5561">leaks/hoses/all belts</li>
                  <li data-id="element-5562">oil level</li>
                  <li data-id="element-5563">coolant level</li>
                  <li data-id="element-5564">power steering fluid</li>
                  <li data-id="element-5565">water pump/fan</li>
                  <li data-id="element-5566">alternator</li>
                  <li data-id="element-5567">air compressor</li>
                </ul>
              </div>
            </div>

            {/* Cab Check/Engine Start */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5568">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5569">
                <h2 className="font-bold text-center text-sm" data-id="element-5570">
                  Cab Check/Engine Start
                </h2>
              </div>
              <div className="p-4" data-id="element-5571">
                <ul className="space-y-1 text-sm" data-id="element-5572">
                  <li data-id="element-5573">clutch/gearshift</li>
                  <li data-id="element-5574">oil pressure gauge</li>
                  <li data-id="element-5575">temperature gauge/voltmeter</li>
                  <li data-id="element-5576">mirrors, windshield</li>
                  <li data-id="element-5577">emer equip (f-e-t) (fa-fl)</li>
                  <li data-id="element-5578">steering play</li>
                  <li data-id="element-5579">wipers/washers</li>
                  <li data-id="element-5580">lighting indicators horn</li>
                  <li data-id="element-5581">heater/defroster</li>
                  <li data-id="element-5582">park/hydraulic brake ck</li>
                  <li data-id="element-5583">air brake ck (loss/warn/tpv-pv)</li>
                  <li data-id="element-5584">safety belt</li>
                </ul>
              </div>
            </div>

            {/* Lights/Reflectors */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5585">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5586">
                <h2 className="font-bold text-center text-sm" data-id="element-5587">
                  Lights/Reflectors
                </h2>
              </div>
              <div className="p-4" data-id="element-5588">
                <ul className="space-y-1 text-sm" data-id="element-5589">
                  <li data-id="element-5590">clearance/strobe</li>
                  <li data-id="element-5591">head</li>
                  <li data-id="element-5592">tail</li>
                  <li data-id="element-5593">turns</li>
                  <li data-id="element-5594">4-ways (amb-red-arm)</li>
                  <li data-id="element-5595">brakes</li>
                  <li data-id="element-5596">reflectors</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Row - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-5597">
            {/* TRAILER */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5598">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5599">
                <h2 className="font-bold text-center text-sm" data-id="element-5600">TRAILER</h2>
              </div>
              <div className="p-4" data-id="element-5601">
                <div className="space-y-3 text-sm" data-id="element-5602">
                  <div data-id="element-5603">
                    <p className="font-bold mb-1" data-id="element-5604">Trailer Front</p>
                    <ul className="space-y-1" data-id="element-5605">
                      <li data-id="element-5606">air/electric connections</li>
                      <li data-id="element-5607">header board</li>
                    </ul>
                  </div>

                  <div data-id="element-5608">
                    <p className="font-bold mb-1" data-id="element-5609">Side of Trailer</p>
                    <ul className="space-y-1" data-id="element-5610">
                      <li data-id="element-5611">landing gear</li>
                      <li data-id="element-5612">doors, ties, lift</li>
                      <li data-id="element-5613">frame</li>
                      <li data-id="element-5614">tandem release arm</li>
                      <li data-id="element-5615">(locking pins)</li>
                    </ul>
                  </div>

                  <div data-id="element-5616">
                    <p className="font-bold mb-1" data-id="element-5617">Wheels</p>
                    <ul className="space-y-1" data-id="element-5618">
                      <li data-id="element-5619">rims</li>
                      <li data-id="element-5620">tires</li>
                      <li data-id="element-5621">axle seals</li>
                      <li data-id="element-5622">lug nuts</li>
                      <li data-id="element-5623">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-5624">
                    <p className="font-bold mb-1" data-id="element-5625">Suspension</p>
                    <ul className="space-y-1" data-id="element-5626">
                      <li data-id="element-5627">springs/air/torque</li>
                      <li data-id="element-5628">mounts</li>
                      <li data-id="element-5629">shocks</li>
                    </ul>
                  </div>

                  <div data-id="element-5630">
                    <p className="font-bold mb-1" data-id="element-5631">Brakes</p>
                    <ul className="space-y-1" data-id="element-5632">
                      <li data-id="element-5633">slack adjustors</li>
                      <li data-id="element-5634">chambers</li>
                      <li data-id="element-5635">hoses/lines</li>
                      <li data-id="element-5636">discs/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5637">
                    <p className="font-bold mb-1" data-id="element-5638">Rear of Trailer</p>
                    <ul className="space-y-1" data-id="element-5639">
                      <li data-id="element-5640">doors, ties, lift</li>
                      <li data-id="element-5641">splash guards</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* SCHOOL BUS/TRUCK/TRACTOR */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5642">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5643">
                <h2 className="font-bold text-center text-sm" data-id="element-5644">
                  SCHOOL BUS/TRUCK/TRACTOR
                </h2>
              </div>
              <div className="p-4" data-id="element-5645">
                <div className="space-y-3 text-sm" data-id="element-5646">
                  <div data-id="element-5647">
                    <p className="font-bold mb-1" data-id="element-5648">Steering</p>
                    <ul className="space-y-1" data-id="element-5649">
                      <li data-id="element-5650">steering box/hoses</li>
                      <li data-id="element-5651">steering linkage</li>
                    </ul>
                  </div>

                  <div data-id="element-5652">
                    <p className="font-bold mb-1" data-id="element-5653">Front Suspension</p>
                    <ul className="space-y-1" data-id="element-5654">
                      <li data-id="element-5655">springs/air</li>
                      <li data-id="element-5656">mounts</li>
                      <li data-id="element-5657">shock</li>
                    </ul>
                  </div>

                  <div data-id="element-5658">
                    <p className="font-bold mb-1" data-id="element-5659">Front Brake</p>
                    <ul className="space-y-1" data-id="element-5660">
                      <li data-id="element-5661">slack adjustor</li>
                      <li data-id="element-5662">chamber</li>
                      <li data-id="element-5663">hose/line</li>
                      <li data-id="element-5664">disc/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5665">
                    <p className="font-bold mb-1" data-id="element-5666">Front Wheel</p>
                    <ul className="space-y-1" data-id="element-5667">
                      <li data-id="element-5668">rim</li>
                      <li data-id="element-5669">tire</li>
                      <li data-id="element-5670">hub oil seal</li>
                      <li data-id="element-5671">lug nuts</li>
                    </ul>
                  </div>

                  <div data-id="element-5672">
                    <p className="font-bold mb-1" data-id="element-5673">Side of Vehicle</p>
                    <ul className="space-y-1" data-id="element-5674">
                      <li data-id="element-5675">Door, mirror, stop arm</li>
                    </ul>
                  </div>

                  <div data-id="element-5676">
                    <p className="font-bold mb-1" data-id="element-5677">Area</p>
                    <ul className="space-y-1" data-id="element-5678">
                      <li data-id="element-5679">Fuel tank</li>
                      <li data-id="element-5680">Battery/box</li>
                      <li data-id="element-5681">Drive shaft</li>
                      <li data-id="element-5682">Exhaust system</li>
                      <li data-id="element-5683">Frame</li>
                    </ul>
                  </div>

                  <div data-id="element-5684">
                    <p className="font-bold mb-1" data-id="element-5685">School/Other Bus</p>
                    <ul className="space-y-1" data-id="element-5686">
                      <li data-id="element-5687">Passenger entry/lifts</li>
                      <li data-id="element-5688">Emergency exits</li>
                      <li data-id="element-5689">Seating</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 3 - Rear Components */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5690">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5691">
                <h2 className="font-bold text-center text-sm" data-id="element-5692">
                  REAR COMPONENTS
                </h2>
              </div>
              <div className="p-4" data-id="element-5693">
                <div className="space-y-3 text-sm" data-id="element-5694">
                  <div data-id="element-5695">
                    <p className="font-bold mb-1" data-id="element-5696">Rear Suspension</p>
                    <ul className="space-y-1" data-id="element-5697">
                      <li data-id="element-5698">spring/air/torque</li>
                      <li data-id="element-5699">shocks</li>
                      <li data-id="element-5700">mounts</li>
                    </ul>
                  </div>

                  <div data-id="element-5701">
                    <p className="font-bold mb-1" data-id="element-5702">Rear brakes</p>
                    <ul className="space-y-1" data-id="element-5703">
                      <li data-id="element-5704">slack adjustors</li>
                      <li data-id="element-5705">chambers</li>
                      <li data-id="element-5706">hoses/lines</li>
                      <li data-id="element-5707">discs/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5708">
                    <p className="font-bold mb-1" data-id="element-5709">Rear wheels</p>
                    <ul className="space-y-1" data-id="element-5710">
                      <li data-id="element-5711">rims</li>
                      <li data-id="element-5712">tires</li>
                      <li data-id="element-5713">lug nuts</li>
                      <li data-id="element-5714">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-5715">
                    <p className="font-bold mb-1" data-id="element-5716">Rear of vehicle</p>
                    <ul className="space-y-1" data-id="element-5717">
                      <li data-id="element-5718">splash guards</li>
                      <li data-id="element-5719">doors, ties, lift</li>
                    </ul>
                  </div>

                  <div data-id="element-5720">
                    <p className="font-bold mb-1" data-id="element-5721">Tractor/Coupling</p>
                    <ul className="space-y-1" data-id="element-5722">
                      <li data-id="element-5723">air/electric lines</li>
                      <li data-id="element-5724">catwalk</li>
                    </ul>
                  </div>

                  <div data-id="element-5725">
                    <p className="font-bold mb-1" data-id="element-5726">Coupling</p>
                    <ul className="space-y-1" data-id="element-5727">
                      <li data-id="element-5728">mounting bolts</li>
                      <li data-id="element-5729">Locking jaws</li>
                      <li data-id="element-5730">kingpin/apron/gap</li>
                      <li data-id="element-5731">platform</li>
                      <li data-id="element-5732">Emergency exits release arm</li>
                      <li data-id="element-5733">sliding 5th wheel</li>
                      <li data-id="element-5734">(locking pins)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* COACH/TRANSIT BUS */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5735">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5736">
                <h2 className="font-bold text-center text-sm" data-id="element-5737">
                  COACH/TRANSIT BUS
                </h2>
              </div>
              <div className="p-4" data-id="element-5738">
                <div className="space-y-3 text-sm" data-id="element-5739">
                  <div data-id="element-5740">
                    <p className="font-bold mb-1" data-id="element-5741">Passenger Items</p>
                    <ul className="space-y-1" data-id="element-5742">
                      <li data-id="element-5743">passenger entry/lifts</li>
                      <li data-id="element-5744">emergency exits</li>
                      <li data-id="element-5745">seating</li>
                    </ul>
                  </div>

                  <div data-id="element-5746">
                    <p className="font-bold mb-1" data-id="element-5747">Entry/Exit</p>
                    <ul className="space-y-1" data-id="element-5748">
                      <li data-id="element-5749">doors/mirrors</li>
                    </ul>
                  </div>

                  <div data-id="element-5750">
                    <p className="font-bold mb-1" data-id="element-5751">Front Suspension</p>
                    <ul className="space-y-1" data-id="element-5752">
                      <li data-id="element-5753">level/air leaks</li>
                    </ul>
                  </div>

                  <div data-id="element-5754">
                    <p className="font-bold mb-1" data-id="element-5755">Front Wheel</p>
                    <ul className="space-y-1" data-id="element-5756">
                      <li data-id="element-5757">rim</li>
                      <li data-id="element-5758">tires</li>
                      <li data-id="element-5759">hub oil seal</li>
                      <li data-id="element-5760">lug nuts</li>
                    </ul>
                  </div>

                  <div data-id="element-5761">
                    <p className="font-bold mb-1" data-id="element-5762">Side of Vehicle</p>
                    <ul className="space-y-1" data-id="element-5763">
                      <li data-id="element-5764">fuel tank</li>
                      <li data-id="element-5765">compartments</li>
                      <li data-id="element-5766">battery/box</li>
                    </ul>
                  </div>

                  <div data-id="element-5767">
                    <p className="font-bold mb-1" data-id="element-5768">Rear Wheels</p>
                    <ul className="space-y-1" data-id="element-5769">
                      <li data-id="element-5770">rims</li>
                      <li data-id="element-5771">tires</li>
                      <li data-id="element-5772">axle seals</li>
                      <li data-id="element-5773">lug nuts</li>
                      <li data-id="element-5774">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-5775">
                    <p className="font-bold mb-1" data-id="element-5776">*Rear Suspension</p>
                    <ul className="space-y-1" data-id="element-5777">
                      <li data-id="element-5778">level/air leak</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center mt-8" data-id="element-5779">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5780">
              Need Professional Vehicle Inspection?
            </h2>
            <p className="text-xl mb-6" data-id="element-5781">
              Certified DOT inspections and comprehensive vehicle safety checks
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5782">
              <Phone className="mr-3" size={24} data-id="element-5783" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5784">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}